(function(){
  var SEL='.lx-reveal';
  function init(root){
    var els=(root||document).querySelectorAll(SEL+':not([data-lx])');
    if(!els.length)return;
    var native=window.CSS&&CSS.supports&&CSS.supports('animation-timeline: view()');
    if(native){els.forEach(function(e){e.setAttribute('data-lx','n');});return;}
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.setAttribute('data-lx','i');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){e.setAttribute('data-lx','p');io.observe(e);});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init();});}else{init();}
  document.addEventListener('shopify:section:load',function(ev){init(ev.target);});
})();
